import { ThemeProperties } from '../../core';

export interface DialogModalTheme {
	background: string;
	borderRadius: string;
	boxShadow: string;
	padding: string;
	zIndex: string;
	gap: string;

	titleFont: string;
	titleFontAtMediumAndAbove: string;

	descriptionFont: string;
	descriptionFontAtMediumAndAbove: string;

	contentFont: string;
}

export const theme = new ThemeProperties('dialogModal');
